import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "@/context/CartContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import Layout from "@/components/Layout";
import MetaPixelTracker from "@/components/MetaPixelTracker";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductPage from "@/pages/Product";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminPreorders from "@/pages/admin/AdminPreorders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminAudit from "@/pages/admin/AdminAudit";

function RequireAuth({ children }) {
  const { admin, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#FAF7F0] text-[#6B6B6B]">Chargement...</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <CartProvider>
            <Toaster
              position="top-right"
              theme="light"
              toastOptions={{
                style: { background: "#FFFFFF", color: "#1A1A1A", border: "1px solid #B8860B", borderRadius: 0 },
              }}
            />
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/produit/:id" element={<ProductPage />} />
                <Route path="/panier" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/change-password" element={<RequireAuth><AdminChangePassword /></RequireAuth>} />

              <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
                <Route index element={<AdminDashboard />} />
                <Route path="produits" element={<AdminProducts />} />
                <Route path="produits/nouveau" element={<AdminProductForm />} />
                <Route path="produits/:id" element={<AdminProductForm />} />
                <Route path="commandes" element={<AdminOrders />} />
                <Route path="precommandes" element={<AdminPreorders />} />
                <Route path="clients" element={<AdminCustomers />} />
                <Route path="temoignages" element={<AdminTestimonials />} />
                <Route path="parametres" element={<AdminSettings />} />
                <Route path="audit" element={<AdminAudit />} />
              </Route>
            </Routes>
          </CartProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
